export const isTokenExpired = (expiresIn) => {
  const expirationDate = new Date(expiresIn).getTime();
  const currentDate = new Date().getTime();
  return expirationDate < currentDate;
};
